<template>
  <div>
    <b-card class="mb-0" no-body>
      <template #header>
        <div class=" d-flex justify-content-start" style="align-items: center;">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-secondary"
            class="d-flex"
            style="align-items:center;"
            @click="back()"
          >
            <feather-icon icon="ArrowLeftCircleIcon" class="mr-50" size="23" />
            <span class="align-middle">{{$t('general_buttons.back')}}</span>
          </b-button>
          <h4 class="mb-0 ml-2">{{$t('fx_spot_forward_swap.titles.selected_amend_details')}}</h4>
        </div>
      </template>
      <b-overlay :show="loading" rounded="sm" no-fade>
        <b-table
          v-if="tradeDetailDatas.length > 0"
          hover
          ref="refFxExecuteTable"
          class="compact_table"
          thead-class="animate__animated animate__fadeIn"
          :items="tradeDetailDatas"
          :filter="filter"
          filter-debounce="250"
          @filtered="onFiltered"
          :filter-included-fields="filterOn"
          selectable
          select-mode="single"
          responsive
          :small="true"
          head-variant="dark"
          :fields="tableColumns"
          show-empty
          :empty-text="$t('fx_spot_forward_swap.messages.no_matching_trade_records')"
          :current-page="currentPage"
          :per-page="perPage"
          :tbody-tr-class="legendClass"
          @row-clicked="viewSelectedTrade"
          caption-top
        >
          <!-- Column: show_details -->
          <!-- <template #cell(show_details)="row">
              <b-form-checkbox
                size="md"
                v-model="row.detailsShowing"
                @change="row.toggleDetails"
                name="check-button"
                button
                v-b-tooltip.hover
                :title="
                  row.detailsShowing
                    ? 'Hide Trade Controls'
                    : 'Show Trade Controls'
                "
                button-variant="flat-primary"
              >
                <feather-icon
                  :icon="row.detailsShowing ? 'EyeOffIcon' : 'EyeIcon'"
                />
              </b-form-checkbox>
            </template> -->

            <!-- Column: ID -->
          <template #cell(ID)="data">
            <b
              ><span class="font-weight-bold text-center">
                <strong>{{ data.item.ID ? data.item.ID : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: TransactionType -->
          <template #cell(TransactionType)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.TransactionType ? data.item.TransactionType : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: EntryDate -->
          <template #cell(EntryDate)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.EntryDate ? dateFormat(data.item.EntryDate) : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: EntryTime -->
          <template #cell(EntryTime)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.EntryTime ? data.item.EntryTime : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: ValueDate -->
          <template #cell(ValueDate)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.ValueDate ? dateFormat(data.item.ValueDate) : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: TcUser -->
          <template #cell(TcUser)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ data.item.TcUser ? data.item.TcUser : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: TcUti -->
          <template #cell(TcUti)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ data.item.TcUti ? data.item.TcUti : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: AccountName1 -->
          <template #cell(AccountName1)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AccountName1 ? data.item.AccountName1 : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: AccountNumber1 -->
          <template #cell(AccountNumber1)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AccountNumber1 ? data.item.AccountNumber1 : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: AccountCode1 -->
          <template #cell(AccountCode1)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AccountCode1 ? data.item.AccountCode1 : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: AccountType1 -->
          <template #cell(AccountType1)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AccountType1 ? data.item.AccountType1 : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Ccy1 -->
          <template #cell(Ccy1)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ data.item.Ccy1 ? data.item.Ccy1 : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Amount1 -->
          <template #cell(Amount1)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.Amount1 ? formatPrice(data.item.Amount1, 2) : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Cost1 -->
          <template #cell(Cost1)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.Cost1 ? formatPrice(data.item.Cost1, 2) : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Description1 -->
          <template #cell(Description1)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.Description1 ? data.item.Description1 : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Note1 -->
          <template #cell(Note1)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ data.item.Note1 ? data.item.Note1 : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: AccountName2 -->
          <template #cell(AccountName2)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AccountName2 ? data.item.AccountName2 : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: AccountNumber2 -->
          <template #cell(AccountNumber2)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AccountNumber2 ? data.item.AccountNumber2 : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: AccountCode2 -->
          <template #cell(AccountCode2)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AccountCode2 ? data.item.AccountCode2 : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: AccountType2 -->
          <template #cell(AccountType2)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AccountType2 ? data.item.AccountType2 : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Ccy2 -->
          <template #cell(Ccy2)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ data.item.Ccy2 ? data.item.Ccy2 : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Amount2 -->
          <template #cell(Amount2)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.Amount2 ? formatPrice(data.item.Amount2, 2) : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Cost2 -->
          <template #cell(Cost2)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.Cost2 ? formatPrice(data.item.Cost2, 2) : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Description2 -->
          <template #cell(Description2)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.Description2 ? data.item.Description2 : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Note2 -->
          <template #cell(Note2)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ data.item.Note2 ? data.item.Note2 : "-" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: RelatedTradeUti -->
          <template #cell(RelatedTradeUti)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.RelatedTradeUti ? data.item.RelatedTradeUti : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: UniqueLinkId -->
          <template #cell(UniqueLinkId)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.UniqueLinkId ? data.item.UniqueLinkId : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: EntryType2 & Main Entry -->
          <template #cell(EntryType2)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{ "Main Entry" }}</strong>
              </span></b
            >
          </template>

          <!-- Column: SavedBy -->
          <template #cell(SavedBy)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.SavedBy ? data.item.SavedBy : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: SaveDate -->
          <template #cell(SaveDate)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.SaveDate != "1900-01-01 00:00:00"
                    ? dateFormat(data.item.SaveDate)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: SaveTime -->
          <template #cell(SaveTime)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.SaveTime != "1900-01-01 00:00:00"
                    ? data.item.SaveTime
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: AmendedBy -->
          <template #cell(AmendedBy)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AmendedBy ? data.item.AmendedBy : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: AmendmentDate -->
          <template #cell(AmendmentDate)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AmendmentDate != "1900-01-01 00:00:00"
                    ? dateFormat(data.item.AmendmentDate)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: AmendmentTime -->
          <template #cell(AmendmentTime)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AmendmentTime != "1900-01-01 00:00:00"
                    ? data.item.AmendmentTime
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: AmendmentReason -->
          <template #cell(AmendmentReason)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AmendmentReason ? data.item.AmendmentReason : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Cancelled -->
          <template #cell(Cancelled)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.Cancelled == 1 ? "Cancelled" : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: CancelledBy -->
          <template #cell(CancelledBy)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CancelledBy ? data.item.CancelledBy : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: CancelDate -->
          <template #cell(CancelDate)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CancelDate != "1900-01-01 00:00:00"
                    ? dateFormat(data.item.CancelDate)
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: CancelTime -->
          <template #cell(CancelTime)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CancelTime != "1900-01-01 00:00:00"
                    ? data.item.CancelTime
                    : "-"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: CancelReason -->
          <template #cell(CancelReason)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.CancelReason ? data.item.CancelReason : "-"
                }}</strong>
              </span></b
            >
          </template>
        </b-table>

        <div class="mx-2 mb-2" v-if="tradeDetailDatas.length > 0">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted" style="font-size:0.8rem"
                >{{$t('general_text.showing')}} {{ dataMeta.from }} {{$t('general_text.to')}} {{ dataMeta.to }} {{$t('general_text.of')}}
                {{ dataMeta.of }} {{$t('general_text.entries')}}</span
              >
            </b-col>

            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0 compact_paginate"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="14" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="14" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>

        <div v-if="tradeDetailDatas.length == 0">
          <b-alert variant="info" show>
            <div class="alert-body text-center">
              <span
                ><strong>{{$t('fx_spot_forward_swap.titles.not_found_trades')}}</strong> <br />
                {{$t('fx_spot_forward_swap.messages.no_amended_trades_found')}}</span
              >
            </div>
          </b-alert>
        </div>
      </b-overlay>

      {{ /*View Selected Trade for trades modal*/ }}
      <ViewSelectedTrade ref="ViewSelectedTrade" />
    </b-card>
  </div>
</template>

<script>
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormRating,
  VBModal,
  BTabs,
  BTab,
  BCardText,
  BIcon,
  BPopover,
} from "bootstrap-vue";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import transfersStoreModule from "../transfersStoreModule";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, alphaNum, email } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import axios from "axios";
import axiosIns from "@/libs/axios";
import router from "@/router";
import moment from "moment";
import "animate.css";
import _ from "lodash";
import { mapState, mapGetters } from "vuex";
import ViewSelectedTrade from "./ViewSelectedDetail.vue";

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BTabs,
    BTab,
    BCardText,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormRating,
    BIcon,
    BPopover,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
    flatPickr,
    ViewSelectedTrade,
  },

  directives: {
    Ripple,
    "b-modal": VBModal,
  },

  setup() {
      const TRANSFERS_APP_STORE_MODULE_NAME = "transfers";
      // Register module
      if (!store.hasModule(TRANSFERS_APP_STORE_MODULE_NAME))
        store.registerModule(
          TRANSFERS_APP_STORE_MODULE_NAME,
          transfersStoreModule
        );
  
      // UnRegister on leave
      onUnmounted(() => {
        if (store.hasModule(TRANSFERS_APP_STORE_MODULE_NAME))
          store.unregisterModule(TRANSFERS_APP_STORE_MODULE_NAME);
      });
    },

  mounted() {
    this.detailId = this.$route.params.id;
    this.getAmendDetailsData(this.$route.params.id);
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      tradeDetailDatas: [],
      detailId: null,
      filterOn: [
        "TcUser",
        "Cpty",
        "Client",
        "OrderGivenThrough",
        "OrderTakenVia",
      ],
      tableColumns: [
      // { key: "show_details", label: "" },
      {
        key: "ID",
        label: "ID",
        // thClass: "text-left",
        tdClass: "text-center",
        // thStyle: 'width: 30%',
        sortable: true,
        class: "text-start table-padding",
        variant: "primary",
      },
      {
        key: "TransactionType",
        label: this.$t("transfers.table.transaction_type"),
        class: "text-start table-padding",
      },
      {
        key: "EntryDate",
        label: this.$t("transfers.table.entry_date"),
        class: "text-start table-padding text-nowrap",
      },
      {
        key: "EntryTime",
        label: this.$t("transfers.table.entry_time"),
        class: "text-start table-padding",
      },
      {
        key: "ValueDate",
        label: this.$t("transfers.table.value_date"),
        class: "text-start table-padding text-nowrap",
      },
      {
        key: "TcUser",
        label: this.$t("transfers.table.operations_user"),
        class: "text-start table-padding",
        sortable: true,
      },

      {
        key: "TcUti",
        label: this.$t("transfers.table.sfc_uti"),
        class: "text-start table-padding",
        sortable: true,
      },
      {
        key: "AccountName1",
        label: this.$t("transfers.table.account_name1"),
        class: "text-start table-padding",
      },
      {
        key: "AccountNumber1",
        label: this.$t("transfers.table.account_number1"),
        class: "text-start table-padding",
      },

      {
        key: "AccountCode1",
        label: this.$t("transfers.table.account_code1"),
        class: "text-start table-padding",
      },

      {
        key: "AccountType1",
        label: this.$t("transfers.table.account_type1"),
        class: "text-start table-padding",
        sortable: true,
      },
      {
        key: "Ccy1",
        label: this.$t("transfers.table.ccy1"),
        class: "text-start table-padding",
      },

      {
        key: "Amount1",
        label: this.$t("transfers.table.amount1"),
        class: "text-start table-padding",
        sortable: true,
      },
      {
        key: "Cost1",
        label: this.$t("transfers.table.cost1"),
        class: "text-start table-padding",
      },
      {
        key: "Description1",
        label: this.$t("transfers.table.description1"),
        class: "text-start table-padding",
      },
      {
        key: "Note1",
        label: this.$t("transfers.table.note1"),
        class: "text-start table-padding",
      },
      {
        key: "AccountName2",
        label: this.$t("transfers.table.account_name2"),
        class: "text-start table-padding",
      },
      {
        key: "AccountNumber2",
        label: this.$t("transfers.table.account_number2"),
        class: "text-start table-padding",
      },

      {
        key: "AccountCode2",
        label: this.$t("transfers.table.account_code2"),
        class: "text-start table-padding",
      },

      {
        key: "AccountType2",
        label: this.$t("transfers.table.account_type2"),
        class: "text-start table-padding",
        sortable: true,
      },
      {
        key: "Ccy2",
        label: this.$t("transfers.table.ccy2"),
        class: "text-start table-padding",
      },

      {
        key: "Amount2",
        label: this.$t("transfers.table.amount2"),
        class: "text-start table-padding",
        sortable: true,
      },
      {
        key: "Cost2",
        label: this.$t("transfers.table.cost2"),
        class: "text-start table-padding",
      },
      {
        key: "Description2",
        label: this.$t("transfers.table.description2"),
        class: "text-start table-padding",
      },
      {
        key: "Note2",
        label: this.$t("transfers.table.note2"),
        class: "text-start table-padding",
      },
      {
        key: "RelatedTradeUti",
        label: this.$t("transfers.table.related_trade_uti"),
        class: "text-start table-padding",
      },
      {
        key: "UniqueLinkId",
        label: this.$t("transfers.table.unique_link_id"),
        class: "text-start table-padding",
      },
      {
        key: "EntryType2",
        label: this.$t("transfers.table.entry_type"),
        class: "text-start table-padding",
      },
      {
        key: "SavedBy",
        label: this.$t("transfers.table.saved_by"),
        class: "text-start table-padding",
      },
      {
        key: "SaveDate",
        label: this.$t("transfers.table.save_date"),
        class: "text-start text-nowrap",
        sortable: true,
      },
      {
        key: "SaveTime",
        label: this.$t("transfers.table.save_time"),
        class: "text-start table-padding",
      },
      {
        key: "AmendedBy",
        label: this.$t("transfers.table.amended_by"),
        class: "text-start table-padding",
      },
      {
        key: "AmendmentDate",
        label: this.$t("transfers.table.amendment_date"),
        class: "text-start table-padding text-nowrap",
        sortable: true,
      },
      {
        key: "AmendmentTime",
        label: this.$t("transfers.table.amendment_time"),
        class: "text-start table-padding",
      },
      {
        key: "AmendmentReason",
        label: this.$t("transfers.table.amendment_reason"),
        class: "text-start table-padding",
      },

      {
        key: "Cancelled",
        label: this.$t("transfers.table.cancelled"),
        class: "text-start table-padding",
      },
      {
        key: "CancelledBy",
        label: this.$t("transfers.table.cancelled_by"),
        class: "text-start table-padding",
      },
      {
        key: "CancelDate",
        label: this.$t("transfers.table.canceled_date"),
        class: "text-start table-padding text-nowrap",
        sortable: true,
      },
      {
        key: "CancelTime",
        label: this.$t("transfers.table.cancelled_time"),
        class: "text-start table-padding",
      },
      {
        key: "CancelReason",
        label: this.$t("transfers.table.cancelled_reason"),
        class: "text-start table-padding",
      },
    ],

      perPage: 25,
      currentPage: 1,
      totalRows: 0,
      perPageOptions: [10, 25, 50, 100],
      filter: null,
      loading: false,
      filterSettlementDate: null,
      filterTradeDate: null,
      canceledReasonText: null,
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.getters["authUser"];
      },
      set(newValue) {
        return this.$store.dispatch("setUser", newValue);
      },
    },
    dataMeta() {
      return {
        from:
          this.totalRows != 0 ? this.perPage * (this.currentPage - 1) + 1 : 0,
        to:
          this.perPage * (this.currentPage - 1) + Number(this.perPage) <
          this.totalRows
            ? this.perPage * (this.currentPage - 1) + Number(this.perPage)
            : this.totalRows,
        of: this.totalRows,
      };
    },
  },
  methods: {
    back() {
      router.go(-1);
    },
    legendClass(item, type) {
      const executedRowColor = "table-executed";
      const verifiedRowColor = "table-verified";
      const journalCreateRowColor = "table-journalCreate";
      const expiredOrderRowColor = "table-expiredOrder";
      const reversedInitiateRowColor = "table-reverseInitiated";
      const reversedRowColor = "table-reversed";
      const canceledRowColor = "table-canceled";

      if (!item || type !== "row") {
        return;
      }

      if (item.Cancelled == 1) {
        return canceledRowColor;
      }
      if (item.Reversed == 1) {
        return reversedRowColor;
      }
      if (item.ReversalInitiated == 1) {
        return reversedInitiateRowColor;
      }
      // if (item.ExpiredOrder == 1) {
      //   return expiredOrderRowColor;
      // }
      if (item.JournalCreated == 1) {
        return journalCreateRowColor;
      }
      if (item.Verified == 1) {
        return verifiedRowColor;
      }
      // if (item.EntryType == "Execution") {
      //   return executedRowColor;
      // }
    },
    getAmendDetailsData(id) {
      this.loading = true;
      this.$checkAccessRight("CashTransactions", "View").then((res) => {
        if (res.data.valid) {
          store
            .dispatch("transfers/getAmendTransferDetailDatas", {
              auth: this.user,
              tradeId: id,
            })
            .then((res) => {
              if (res.data.info == "Pass") {
                this.tradeDetailDatas.push(res.data.trade);
             
                if (res.data.details.length > 0) {
                  res.data.details.forEach((data) => {
                    this.tradeDetailDatas.push(data);
                  });
                }
                this.totalRows = this.tradeDetailDatas.length;
                this.loading = false;
              } else {
                this.notFoundMessage();
                this.loading = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.loading = false;
        }
      });
    },
    viewSelectedTrade(item) {
      this.$checkAccessRight("CashTransactions", "View").then((res) => {
        if (res.data.valid) {
          if (item.ID != 0) {
            if (this.detailId == item.ID) {
              store
                .dispatch("transfers/getViewSelectedTransferTrade", {
                  auth: this.user,
                  tradeId: item.ID,
                  tcUti: item.TcUti,
                })
                .then((res) => {
                  if (res.data.info == "Pass") {
                    this.$refs.ViewSelectedTrade.viewSelectedTradeModal = true;
                    this.$refs.ViewSelectedTrade.fetchedTradeData =
                      res.data.trade;

                    //set timeline datas
                    let actionsArray = [];
                    if (
                      res.data.trade.SavedBy != null &&
                      res.data.trade.SavedBy != ""
                    ) {
                      actionsArray.push({
                        type: "Saved",
                        user: res.data.trade.SavedBy ?? "",
                        date:
                          res.data.trade.SaveDate.split(" ")[0] +
                          " " +
                          res.data.trade.SaveTime.split(" ")[1],
                        reason: "-",
                      });
                    }

                    if (
                      res.data.trade.AmendedBy != null &&
                      res.data.trade.AmendedBy != ""
                    ) {
                      actionsArray.push({
                        type: "Amended",
                        user: res.data.trade.AmendedBy ?? "",
                        date:
                          res.data.trade.AmendmentDate.split(" ")[0] +
                          " " +
                          res.data.trade.AmendmentTime.split(" ")[1],
                        reason: res.data.trade.AmendmentReason,
                      });
                    }
                    if (res.data.actions.length > 0) {
                      if (
                        res.data.actions[0].VerificationUser != null &&
                        res.data.actions[0].VerificationUser != ""
                      ) {
                        this.$refs.ViewSelectedTrade.checkVerify = true;
                        actionsArray.push({
                          type: "Verified",
                          user: res.data.actions[0].VerificationUser ?? "",
                          date: res.data.actions[0].VerificationDateTime,
                          reason: "-",
                        });
                      }
                    }

                    if (res.data.actions.length > 0) {
                      if (
                        res.data.actions[0].JournalUser != null &&
                        res.data.actions[0].JournalUser != ""
                      ) {
                        actionsArray.push({
                          type: "Journal Created",
                          user: res.data.actions[0].JournalUser ?? "",
                          date: res.data.actions[0].JournalDateTime,
                          reason: "-",
                        });
                      }
                    }

                    if (
                      res.data.trade.CancelledBy != null &&
                      res.data.trade.CancelledBy != ""
                    ) {
                      actionsArray.push({
                        type: "Canceled",
                        user: res.data.trade.CancelledBy ?? "",
                        date:
                          res.data.trade.CancelDate.split(" ")[0] +
                          " " +
                          res.data.trade.CancelTime.split(" ")[1],
                        reason: res.data.trade.CancelReason,
                      });
                    }

                    if (res.data.actions.length > 0) {
                      if (
                        res.data.actions[0].ReversalInitiatedBy != null &&
                        res.data.actions[0].ReversalInitiatedBy != ""
                      ) {
                        actionsArray.push({
                          type: "Reversal Initiated",
                          user: res.data.actions[0].ReversalInitiatedBy ?? "",
                          date: res.data.actions[0].ReversalInitiatedDateTime,
                          reason: res.data.actions[0].ReversalInitiatedReason,
                        });
                      }
                    }

                    if (res.data.actions.length > 0) {
                      if (
                        res.data.actions[0].ReversedBy != null &&
                        res.data.actions[0].ReversedBy != ""
                      ) {
                        actionsArray.push({
                          type: "Reversed",
                          user: res.data.actions[0].ReversedBy ?? "",
                          date: res.data.actions[0].ReversedDateTime,
                          reason: "-",
                        });
                      }
                    }

                    this.$refs.ViewSelectedTrade.actionsData = actionsArray;
                  } else {
                    this.notFoundMessage();
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            } else {
              store
                .dispatch("transfers/getViewSelectedTransferTrade", {
                  auth: this.user,
                  tradeId: item.ID,
                  tcUti: item.TcUti,
                })
                .then((res) => {
                  if (res.data.info == "Pass") {
                    this.$refs.ViewSelectedTrade.viewSelectedTradeModal = true;
                    this.$refs.ViewSelectedTrade.fetchedTradeData =
                      res.data.trade;

                    //set timeline datas
                    let actionsArray = [];
                    if (
                      res.data.trade.SavedBy != null &&
                      res.data.trade.SavedBy != ""
                    ) {
                      actionsArray.push({
                        type: "Saved",
                        user: res.data.trade.SavedBy ?? "",
                        date:
                          res.data.trade.SaveDate.split(" ")[0] +
                          " " +
                          res.data.trade.SaveTime.split(" ")[1],
                        reason: "-",
                      });
                    }

                    if (
                      res.data.trade.AmendedBy != null &&
                      res.data.trade.AmendedBy != ""
                    ) {
                      actionsArray.push({
                        type: "Amended",
                        user: res.data.trade.AmendedBy ?? "",
                        date:
                          res.data.trade.AmendmentDate.split(" ")[0] +
                          " " +
                          res.data.trade.AmendmentTime.split(" ")[1],
                        reason: res.data.trade.AmendmentReason,
                      });
                    }
                    if (res.data.actions.length > 0) {
                      if (
                        res.data.actions[0].VerificationUser != null &&
                        res.data.actions[0].VerificationUser != ""
                      ) {
                        this.$refs.ViewSelectedTrade.checkVerify = true;
                        actionsArray.push({
                          type: "Verified",
                          user: res.data.actions[0].VerificationUser ?? "",
                          date: res.data.actions[0].VerificationDateTime,
                          reason: "-",
                        });
                      }
                    }

                    if (res.data.actions.length > 0) {
                      if (
                        res.data.actions[0].JournalUser != null &&
                        res.data.actions[0].JournalUser != ""
                      ) {
                        actionsArray.push({
                          type: "Journal Created",
                          user: res.data.actions[0].JournalUser ?? "",
                          date: res.data.actions[0].JournalDateTime,
                          reason: "-",
                        });
                      }
                    }

                    if (
                      res.data.trade.CancelledBy != null &&
                      res.data.trade.CancelledBy != ""
                    ) {
                      actionsArray.push({
                        type: "Canceled",
                        user: res.data.trade.CancelledBy ?? "",
                        date:
                          res.data.trade.CancelDate.split(" ")[0] +
                          " " +
                          res.data.trade.CancelTime.split(" ")[1],
                        reason: res.data.trade.CancelReason,
                      });
                    }

                    if (res.data.actions.length > 0) {
                      if (
                        res.data.actions[0].ReversalInitiatedBy != null &&
                        res.data.actions[0].ReversalInitiatedBy != ""
                      ) {
                        actionsArray.push({
                          type: "Reversal Initiated",
                          user: res.data.actions[0].ReversalInitiatedBy ?? "",
                          date: res.data.actions[0].ReversalInitiatedDateTime,
                          reason: res.data.actions[0].ReversalInitiatedReason,
                        });
                      }
                    }

                    if (res.data.actions.length > 0) {
                      if (
                        res.data.actions[0].ReversedBy != null &&
                        res.data.actions[0].ReversedBy != ""
                      ) {
                        actionsArray.push({
                          type: "Reversed",
                          user: res.data.actions[0].ReversedBy ?? "",
                          date: res.data.actions[0].ReversedDateTime,
                          reason: "-",
                        });
                      }
                    }

                    this.$refs.ViewSelectedTrade.actionsData = actionsArray;
                  } else {
                    this.notFoundMessage();
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          } else {
            this.tradeIDDoesntZeroMessage();
          }
        } else {
          this.notAuthToastMessage();
        }
      });
    },

    databaseErrorMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: this.$t('fx_spot_forward_swap.toast_messages.database_connection_error'),
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    },
    errorMessage(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: message,
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    },
    notFoundMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Not Found",
          text: this.$t('fx_spot_forward_swap.toast_messages.data_not_found'),
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    wrongToastMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: val,
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    notAuthToastMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Not Authorized",
          text: this.$t('fx_spot_forward_swap.general_messages.not_authorized_message'),
          icon: "UserXIcon",
          variant: "warning",
        },
      });
    },

    tradeIDDoesntZeroMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Warning",
          text: this.$t('fx_spot_forward_swap.messages.trade_id_cannot_zero'),
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    dateFormat(val) {
      if (val != undefined) {
        return moment(String(val)).format("DD-MM-YYYY");
      }
    },
    dateFormatWithTime(val) {
      if (val != undefined) {
        return moment(String(val)).format("MM-DD-YYYY HH:mm:ss");
      }
    },
    DMYdateFormat(val) {
      if (val != undefined) {
        return moment(String(val), "DD-MM-YYYY").format("DD-MM-YYYY");
      }
    },
    timeFormat(val) {
      if (val != undefined) {
        return moment(String(val)).format("HH:mm:ss");
      }
    },
    formatPrice(value, val) {
      if (value != null) {
        let val = (value / 1).toFixed(2).replace(",", ".");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    YMDdateFormat(val) {
      if (val != undefined) {
        return moment(String(val), "DD-MM-YYYY").format("YYYY-MM-DD");
      }
    },
    clearTradeDate() {
      this.filterTradeDate = null;
      this.runLastSearch();
    },
    clearSettlementDate() {
      this.filterSettlementDate = null;
      this.runLastSearch();
    },
    handleScroll(e) {
      // this.windowTop = window.top.scrollY
      // if(this.windowTop > 300) {
      //   console.log(this.$refs.refFxExecuteTable.$el)
      // }
    },
  },
  watch: {
    perPage: {
      handler: function(val, before) {
        localStorage.setItem("AmendDetailsShow", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.top-btns {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.table-purple {
  background: purple;
}
.table-executed {
  background-color: paleturquoise !important;
}
.table-verified {
  background-color: black !important;
}
.table-journalCreate {
  background-color: mediumpurple !important;
}
.table-expiredOrder {
  background-color: silver !important;
}
.table-reverseInitiated {
  background-color: #ffff99 !important;
}
.table-reversed {
  background-color: #f8ac91 !important;
}
.table-canceled {
  background-color: #ffb8b8 !important;
}

.ID_background {
  background-color: gainsboro !important;
}

/* width */
::-webkit-scrollbar {
    width: 5px;
    height:5px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey; 
    border-radius: 10px;
  }
   
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: grey;
    border-radius: 10px;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: rgb(77, 73, 73); 
  }
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<!-- compact design scss code -->
  
<style lang="scss" scoped>
  
  @import "~/src/assets/scss/compact-design.scss";


.card::v-deep .card-body {
    padding: 0.8rem 0.7rem !important;
  
    .card-title {
        font-weight: 500 !important;
        font-size: 1.285rem !important;
        margin-bottom: 0.6rem !important;
        text-decoration: none !important;
    }
  }
</style>
